import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowRightIcon from "../../svg/ArrowRightIcon";

export default function BackButton({ fallbackPath = '/', path=null, className = '', children = 'Tilbake',
								   style={}}) {
	const navigate = useNavigate();

	const handleBack = () => {
		if (path) {
			// navigate and remove self from history
			navigate(path, { replace: true });
		}
		else if (window.history.state && window.history.state.idx > 0) {
			navigate(-1,  { replace: true }); // Navigate back to the previous page
		} else {
			navigate(fallbackPath,  { replace: true }); // Navigate to fallbackPath if no history
		}
	};

	return (
		<button onClick={handleBack} className={className} style={{
			display:'flex', alignItems: 'center', justifyContent: 'center', width:'fit-content', height:'fit-content', border: 'none', background: 'none', outline: 'none', cursor: 'pointer', fontSize: '1.1rem', marginTop: '10px', marginBottom: '10px', float: 'left',
			borderBottom: '2px solid', ...style
		}}>
			<ArrowRightIcon rotate={true}/>
			{children}
		</button>
	);
};